import { RoundedPopover, RoundedPopoverList, popoverRightProperties } from '@/components/Popover/RoundedPopover';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useAuthService } from '@/services/auth';
import { AccountCircle } from '@mui/icons-material';
import LogoutIcon from '@mui/icons-material/Logout';
import { Divider, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { StyledListHeader, StyledListItem } from '../AssetsPage/PopoverList';
import { BodyText } from '../BodyText';

const StyledIconButton = styled(IconButton)({
  color: '#ffffff',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
});

export const AccountButton = () => {
  const { data: currentUser, tenantRoleLabel } = useGetCurrentUser();
  const { logout } = useAuthService();
  const [accountAnchorElement, setAccountAnchorElement] = useState<HTMLButtonElement | undefined>();

  const handleAccountClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAccountAnchorElement(event.currentTarget);
  };

  const handleAccountClose = () => {
    setAccountAnchorElement(undefined);
  };

  const handleSignOutClick = () => {
    logout();
    handleAccountClose();
  };

  const accountOpen = Boolean(accountAnchorElement);

  return (
    <>
      <StyledIconButton onClick={handleAccountClick}>
        <AccountCircle />
      </StyledIconButton>
      <RoundedPopover
        open={accountOpen}
        anchorEl={accountAnchorElement}
        onClose={handleAccountClose}
        {...popoverRightProperties}
      >
        <RoundedPopoverList>
          <StyledListHeader>
            <BodyText>
              {tenantRoleLabel}
              {currentUser?.user?.displayName ? `: ${currentUser?.user?.displayName}` : ''}
            </BodyText>
          </StyledListHeader>
          <Divider />

          <StyledListItem onClick={handleSignOutClick}>
            <ListItemIcon sx={{ minWidth: '32px' }}>
              <LogoutIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary='Sign out' />
          </StyledListItem>
        </RoundedPopoverList>
      </RoundedPopover>
    </>
  );
};
